'use strict';

function getSharedRedemptionData(data, type = 'REDEEM') {
  const {
    offerId,
    offerTitle,
    offerType,
    offerCode,
    expiryDateTime,
    termsAndConditions,
    financialTerms,
    isLimitedGlobally,
    isLimitedPerUser,
  } = data;

  return {
    offerId,
    offerTitle,
    offerType,
    offerCode,
    expiryDateTime,
    termsAndConditions,
    financialTerms,
    isLimited: isLimitedGlobally || isLimitedPerUser,
    type,
  };
}

function getMerchantFromOfferOrRedemption(data) {
  const dataFromOfferOrRedemption = data.merchant || data;
  const { merchantId, merchantName, merchantMedia } = dataFromOfferOrRedemption;

  return { merchantId, merchantName, merchantMedia };
}

function getOfferRedemptionData(data, type = 'REDEEM') {
  const shared = getSharedRedemptionData(data, type);
  const merchant = getMerchantFromOfferOrRedemption(data);

  return {
    ...shared,
    ...merchant,
  };
}

module.exports = { getOfferRedemptionData };
